import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
type Plan = {
  name: string;
  ideal: string;
  was?: string;
  now: string;
  features: string[];
  cta: string;
};
const plans: Plan[] = [{
  name: '📘 ACADEMIA CEMENTO ELITE™',
  ideal: 'Artesanos y emprendedores que quieren vivir de fabricar objetos de lujo en cemento sin desperdiciar materiales ni vender barato',
  was: '$54.990 ARS',
  now: '$19.990 ARS',
  features: ['12 Tomos completos de fabricación y venta', 'Sistema de mezcla sin grietas garantizado', 'Calculadora de costos anti-inflación incluida', 'Mapa de proveedores mayoristas en Argentina', 'Hoja de ruta: de cero a primera venta en 30 días', 'Meta Ads Express para decoración ARG', '5 Bonos estratégicos gratis ($51.000 de valor)', 'Garantía 7 días sin preguntas'],
  cta: 'Quiero la Academia Cemento Elite'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Precios" className="bg-radial-glow" data-id="element-122" data-mp="9q5q9juym4nk">
      <div className="mx-auto max-w-5xl px-5 pt-[18px] pb-[23px]" data-id="element-123" data-mp="eqti27r0ipiu">
        <div className="mx-auto flex w-full max-w-xl flex-col items-stretch gap-6" data-id="element-124" data-mp="3d9qo4bbvx4sp">
          {plans.map((plan, i) => <motion.div key={plan.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="relative flex w-full flex-col items-center rounded-3xl border border-gold/45 bg-ink-2 px-7 pt-10 pb-7 text-center shadow-[0_20px_60px_-20px_rgba(229,185,75,0.35)]" data-id="element-125" data-mp="3i8tuq07ijj2s" data-mpi={i}>
              <h3 className="font-display text-lg font-black text-white" data-id="element-126" data-mp="2rgcyy442ytzh">{plan.name}</h3>
              <p className="mt-2 text-sm text-white/60" data-id="element-127" data-mp="2mi1p3tdscjh9">
                <span className="font-semibold text-white/80" data-id="element-128" data-mp="2mhi4u60nxj02">Ideal para:</span> {plan.ideal}
              </p>

              <div className="mt-6" data-id="element-129" data-mp="318r2n2epyaoa">
                {plan.was && <span className="text-base font-medium text-white/40 line-through" data-id="element-130" data-mp="2w83b8fmkvrtj">
                    {plan.was}
                  </span>}
                <div className="font-display text-4xl font-black text-gold-shine" data-id="element-131" data-mp="23jfki4j28a8l">{plan.now}</div>
                <p className="mt-1 text-xs font-semibold text-cemento-soft" data-id="element-132" data-mp="2igpsv50ep003">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <p className="mt-6 w-full text-left text-sm font-bold text-white" data-id="element-133" data-mp="2dj6cnzk5ed5i">
                ✅ Tu acceso completo incluye:
              </p>
              <ul className="mt-3 w-full flex-1 space-y-3 text-left" data-id="element-134" data-mp="3ox1szbmsgryb">
                {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-white/80" data-id="element-135" data-mp="9m0obr0ji81">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} data-id="element-136" data-mp="5ai12fc5om8p" />
                    {f}
                  </li>)}
              </ul>

              <div className="mt-7 w-full" data-id="element-137" data-mp="3rg56tdlwmk00">
                <CTAButton size="md" variant="gold" className="w-full" data-id="element-138" data-mp="3rh6ssd4gkqwi">
                  {plan.cta}
                </CTAButton>
              </div>

              <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-white/50" data-id="element-139" data-mp="nzomia4c3ry7">
                {trust.map(({
              icon: Icon,
              label
            }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-140" data-mp="ea52300z3q18">
                    <Icon className="h-4 w-4 text-cemento" data-id="element-141" data-mp="e7sdi40pmhf7" />
                    {label}
                  </span>)}
              </div>
            </motion.div>)}
        </div>

        <div className="mx-auto mt-8 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-cemento/30 bg-white/5 p-5 text-left" data-id="element-142" data-mp="16saicuf8riis">
          <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" data-id="element-143" data-mp="3a85w5imwchjc" />
          <p className="text-sm leading-relaxed text-white/75" data-id="element-144" data-mp="3592rw0eqqfcf">
            <span className="font-bold text-white" data-id="element-145" data-mp="359m8ndsnmxov">Garantía de devolución de 7 días.</span> Si abrís
            los tomos y en la primera semana sentís que no vale lo que pagaste, pedís el reembolso y
            te devolvemos el 100%. Sin formularios, sin drama, sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}